
import { Component,Prop, BaseMixins } from '@/lib';
import Icons from '../icons/index.vue'

@Component({
    name:"hicon",
    components:{Icons}
})
export default class Hicon extends BaseMixins {
    name:string= 'Hicon';
    @Prop({type:String,required: true}) type:string;
    @Prop({type:String,default:'#5c6b77'}) color:string;
    @Prop({type:Number,default:16}) size:number;

    get iconType () {
      return this.type.indexOf('_') === 0 ? 'Icons' : 'Icon'
    }
    get iconName () {
      return this.iconType === 'Icons' ? this.getCustomIconName(this.type) : this.type
    }
    get iconSize () {
      return this.size || (this.iconType === 'Icons' ? 12 : undefined)
    }
    get iconColor () {
      return this.color || ''
    }

    getCustomIconName (iconName) {
      return iconName.slice(1)
    }
}
